<template>
	<section>
		<div class="container--main">
			<div class="add-class">
				<h1 class="classname">Mon Compte</h1>
			</div>
			<div class="button__container">
				<router-link v-if="!isSSO" :to="{ name: 'EditProfile' }" class="button button--primary">Modifier mon compte</router-link>
				<button class="button button--secondary button--red"
						@click="logout">Se déconnecter</button>
			</div>
		</div>
		<div class="parameter-container">
			<profile-router />
		</div>
	</section>
</template>

<script>
import Config from '../../../config'
import ProfileRouter from './ProfileRouter.vue'

export default {
	components: {
		ProfileRouter,
	},
	computed: {
		isSSO() {
			return this.$store.getters.isSSO
		}
	},
	methods: {
		logout() {
			this.$store.dispatch('logout')
			location.replace(`${Config.landing_url}/auth/reset-token`)
		},
	}
};
</script>

<style>
</style>
